import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { ecaAdvantages } from "../ecaModulesData";

const EcaAdvantagesSection: React.FC = () => (
  <section className="wdev-process" aria-labelledby="eca-advantages-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2
          id="eca-advantages-title"
          className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
        >
          Platform Advantages
        </h2>
        <p className="eca-section-lead eca-section-lead--dark">
          A scalable e-commerce platform for startups, enterprises, and marketplace operators.
        </p>
      </AnimatedSection>

      <div className="eca-advantages-grid">
        {ecaAdvantages.map((advantage, index) => (
          <motion.div
            key={advantage}
            className="wdev-process__card eca-advantage-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
            whileHover={{ y: -4, transition: { duration: 0.25 } }}
          >
            <p className="eca-advantage-card__text">{advantage}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default EcaAdvantagesSection;
